import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HighlightedProduct } from "src/features/highlighted-product/model/HighlightedProduct";
import {
  setCombinedProductSummaries,
  setIsCombinedModalVisible,
} from "../combinedProductSlice";
import { isVisibleSelector, productsSelector } from "../combinedProductSlice";

const useCombinedProductModal = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(isVisibleSelector);
  const combinedProducts = useSelector(productsSelector);

  // Todo move below function
  function openCombinedModal(data: HighlightedProduct[]) {
    // hide existing product modal

    // for each product,  set product summary
    dispatch(setCombinedProductSummaries(data));

    dispatch(setIsCombinedModalVisible(true));
  }

  return {
    isVisible,
    openCombinedModal,
    combinedProducts,
  };
};

export default useCombinedProductModal;
